import { COLORS } from '@btime/constants'
import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import ControlledModal from '../../../components/modals/ControlledModal'
import LinkTreeLoader from './_load/LinkTreeLoader'
import LinkTreesTable from './table/LinkTreesTable'
import ModalHeader from './ModalHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import SearchBar from './SearchBar'

const LinkTreeSettingsModal = props => {
  return (
    <ControlledModal width="54rem" disableClickOutside {...props}>
      <FilterHandler tempStorageNamespace="linkTrees" initialState={{}}>
        <ModalHeader />
        <HorizontalLine thin lineColor={COLORS.light2} />
        <SearchBar />
        <LinkTreeLoader>
          <Separator weight={2} />
          <LinkTreesTable />
          <Separator weight={5} />
        </LinkTreeLoader>
      </FilterHandler>
    </ControlledModal>
  )
}

export default LinkTreeSettingsModal
